export default {
	firstname: "Nome",
	lastname: "Cognome",
	phone: "Numero di telefono",
	language: "Lingua",
	newsletterSubscribe: "Iscriviti alla newsletter",
	newsletterSubscribed:
		"Iscritto alla newsletter. Se lo desidera, può nuovamente disiscriversi al prossimo invio.",
	usernameEmail: "Nome utente / E-mail",
	changeUsernameTooltip:
		"Clicchi qui per modificare l'indirizzo e-mail / nome utente. Il nuovo nome utente verrà impostato in una finestra di dialogo.",
	changePasswordButton: "Modifica password",
	changePasswordTooltip: "Clicchi qui per modificare la sua password.",
	appCodeLabel: "Codice app per il componente aggiuntivo Fusion 360 / SolidWorks",
	appCodeDescription:
		"Se progetta con Autodesk Fusion 360 o SolidWorks, le consigliamo di utilizzare il componente aggiuntivo Blexon. Installi il componente per {fusion} o {solidworks} e lo colleghi con il codice app sopra riportato al negozio Blexon. In questo modo può caricare i suoi modelli CAD direttamente nel negozio Blexon senza esportazione/importazione.",
	appCodeSecrecy:
		"Mantenga segreto il suo codice app e non lo condivida in nessun caso con terzi. Se il suo codice app è stato reso accessibile, generi assolutamente un nuovo codice.",
	copyAppCode: "Copia",
	copyAppCodeTooltip: "Copia il codice negli appunti",
	regenerateAppCode: "Rigenera",
	regenerateAppCodeTooltip:
		"Clicchi qui per generare un nuovo codice. L'accesso con il vecchio codice non sarà più possibile.",
	changeUsernameDialog: {
		title: "Modifica del nome utente",
		text: "Il suo indirizzo e-mail è anche il suo nome utente per l'accesso.",
		text2: "Se modifica il suo indirizzo e-mail, cambierà anche il suo nome utente. La preghiamo di tenerne conto al prossimo accesso.",
		newUsernameLabel: "Nuovo nome utente / E-mail",
		hint: "Nota:",
		hintText:
			"Questo non è l'indirizzo e-mail per l'invio delle fatture. Lo trova nelle impostazioni dell'indirizzo di fatturazione.",
	},
	emailChangeRegisteredDialog: {
		title: "E-mail di conferma inviata",
		text: "Riceverà un'e-mail di conferma al nuovo indirizzo indicato.",
		text2: "Cliccando sul link in essa contenuto, la modifica verrà attivata.",
	},
	emailChangeFailedDialog: {
		title: "Modifica non riuscita",
		text: "Non è stato possibile eseguire la modifica.",
		text2: "Verifichi che l'indirizzo e-mail sia corretto e valido.",
		text3: "Potrebbe già esistere un conto Blexon con questo indirizzo e-mail.",
		text4: "Se ritiene che il nuovo indirizzo e-mail sia valido e le appartenga, contatti il nostro helpdesk.",
	},
	changePasswordDialog: {
		title: "Modifica password",
		text: "Le invieremo un'e-mail a {username}. Contiene un codice e un link alla pagina in cui può impostare una nuova password utilizzando il codice.",
		text2: "La preghiamo di controllare anche la cartella spam se non riceve l'e-mail.",
	},
	messages: {
		usernameSame:
			"Il nuovo nome utente è identico a quello attuale o a uno già richiesto.",
		saveSuccess: "Impostazioni salvate con successo.",
		saveError: "Non è stato possibile salvare le impostazioni.",
		passwordChangeMailSent: "L'e-mail per la modifica della password è stata inviata.",
		passwordChangeMailError: "Non è stato possibile inviare l'e-mail per la modifica della password.",
		appCodeCopied: "Codice app copiato con successo negli appunti.",
		appCodeGenerateError: "Errore durante la generazione del codice app. Si rivolga al nostro helpdesk.",
	},
};
